import update, { Spec } from 'immutability-helper'

const actionsRegister = new Set()

export function useStateRedux<S>(
  actionName: string
): [typeof setState, typeof reducer] {
  if (actionsRegister.has(actionName)) console.warn('useStateRedux name clash')
  else actionsRegister.add(actionName)
  function setState(nextState: Partial<S>, desc = '') {
    return {
      type: actionName.toUpperCase(),
      desc,
      nextState,
    }
  }
  function reducer(state: S, action: ReturnType<typeof setState>) {
    return { ...state, ...action.nextState }
  }
  return [setState, reducer]
}

export function useUpdateRedux<S>(
  actionName: string
): [typeof useUpdate, typeof reducer] {
  if (actionsRegister.has(actionName)) console.warn('useUpdateRedux name clash')
  else actionsRegister.add(actionName)

  return [useUpdate, reducer]

  function useUpdate(patch: Spec<S>, desc = '') {
    return {
      type: actionName.toUpperCase(),
      desc,
      patch,
    }
  }
  function reducer(state: S, action: ReturnType<typeof useUpdate>) {
    return update(state, action.patch)
  }
}
